import React from 'react';
import { Formik, Form } from 'formik';
import { Box, Select, MenuItem } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import CommonButton from '../../../common/CommonButton';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {
  BLACK_COLOR,
  VERY_LIGHT_GREY_COLOR,
} from '../../../../const/color-const';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  cashFormWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(1, 0, 2, 0),
    '& div': {
      flexWrap: 'wrap',
    },
  },
  selectCashRegister: {
    background: theme.palette.type === 'light' ? 'white' : BLACK_COLOR,
    width: 240,
  },
  stepContainer: {
    padding: theme.spacing(4, 0, 4, 0),
    borderBottom: `1px solid ${VERY_LIGHT_GREY_COLOR}`,
  },
}));

const AdministrationBookkeepingForm = ({
                                         machineId,
                                         machinesOptions,
                                         handleMachineIdChange,
                                         fetchBookkeepingSettings,
                                       }) => {
  
  const classes = useStyles();
  
  React.useEffect(() => {
    fetchBookkeepingSettings(machineId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchBookkeepingSettings]);
  
  return (
    <div className={classes.cashFormWrapper}>
      <Formik
        initialValues={{ search: 'searchText' }}
        onSubmit={(values, { setSubmitting }) => {
          fetchBookkeepingSettings(machineId, setSubmitting);
        }}>
        {({ isSubmitting }) => (
          <Form>
            <Box display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'center'}>
              <Select
                className={classes.selectCashRegister}
                variant="outlined"
                value={machineId}
                onChange={(event) => handleMachineIdChange(event)}>
                {machinesOptions.map((machine) => (
                  <MenuItem value={machine.value} key={machine.value}>
                    {machine.label}
                  </MenuItem>
                ))}
              </Select>
              <CommonButton
                disabled={isSubmitting}
                isAnimated
                searchButton
                size="large"
                type="submit"
                label={<FormattedMessage id="search" defaultMessage="Search" />}
              />
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  );
};

AdministrationBookkeepingForm.propTypes = {
  machineId: PropTypes.string,
  handleMachineIdChange: PropTypes.func,
  machinesOptions: PropTypes.array,
  fetchBookkeepingSettings: PropTypes.func,
};

export default AdministrationBookkeepingForm;
